var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_577",
    "data-name": "Rectangle 577",
    width: 36,
    height: 36,
    transform: "translate(238 606)",
    fill: "#e6e6e6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-238 -606)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_003-twitter",
    "data-name": "003-twitter",
    d: "M36,5.713a15.387,15.387,0,0,1-4.253,1.165A7.339,7.339,0,0,0,34.994,2.8a14.749,14.749,0,0,1-4.68,1.786A7.38,7.38,0,0,0,17.548,9.632a7.6,7.6,0,0,0,.171,1.683A20.89,20.89,0,0,1,2.507,3.6,7.382,7.382,0,0,0,4.774,13.46a7.289,7.289,0,0,1-3.334-.909v.081a7.414,7.414,0,0,0,5.913,7.252,7.366,7.366,0,0,1-1.935.243A6.525,6.525,0,0,1,4.021,20a7.451,7.451,0,0,0,6.9,5.141,14.829,14.829,0,0,1-9.151,3.148A13.824,13.824,0,0,1,0,28.188,20.778,20.778,0,0,0,11.322,31.5c13.581,0,21.006-11.25,21.006-21,0-.326-.011-.641-.027-.954A14.723,14.723,0,0,0,36,5.713Z",
    transform: "translate(238 607.125)",
    fill: "#03a9f4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter-logo.3803ac03055e327e66d522549d786800.svg";
export { ForwardRef as ReactComponent };